module.exports = "/_next/static/images/logo512-50060031941f3bdd948ff9faaaaa05f8.png";